import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({
  id,
  input,
  disabled,
  maxLength
}) => (
  <input id={id} type="text" autoComplete="off" maxLength={maxLength} {...input} disabled={disabled} />
);

function TextField(props) {
  return <BaseField fieldClassName="textField" renderFieldContent={renderFieldContent} {...props} />;
}

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number
};

renderFieldContent.defaultProps = {
  disabled: false,
  maxLength: null
};

export default TextField;
